import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Globe } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { trackInitiateCheckout } from './MetaPixel';
import { CHECKOUT_URL, OFFER } from '../data/offer';
const INCLUDES = ['6 tomos clínicos', '5 herramientas de consulta', 'Casos, pruebas y razonamiento aplicado', 'Acceso digital inmediato'];
export function PricingOptions() {
  return <AnimatedSection id="pricing" className="bg-navy-950 relative overflow-hidden pt-12 pb-10 sm:pt-16 sm:py-14 md:py-16 scroll-mt-4" data-id="element-156" data-mp="3r8jeojy5gnw5">
      {/* Elegant transition from the light section above */}
      <div aria-hidden className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white/[0.06] to-transparent pointer-events-none" data-id="element-157" data-mp="3he9b063rc364" />
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" data-id="element-158" data-mp="dt3k5tg61s58">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, rgba(201,168,76,0.4) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-159" data-mp="90ka36gotf56" />
      </div>
      <div className="absolute top-1/4 -left-40 w-[460px] h-[460px] bg-gold/[0.07] blur-[120px] rounded-full pointer-events-none" data-id="element-160" data-mp="3rmh3xvgue0fb"></div>

      <div className="relative max-w-lg mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161" data-mp="3hu1i2n2fcrp5">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative bg-navy-800 border-2 border-gold rounded-3xl px-4 py-5 sm:px-7 sm:py-8 shadow-[0_0_60px_rgba(201,168,76,0.2)]" data-id="element-162" data-mp="33vbld8jiou1b">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-163" data-mp="x4uae1px94j5">
            <div className="inline-flex items-center bg-gold text-navy-950 font-extrabold px-3.5 py-1 rounded-full text-[9.5px] sm:text-[11px] tracking-[0.14em] uppercase shadow-[0_6px_18px_rgba(201,168,76,0.4)] whitespace-nowrap" data-id="element-164" data-mp="vnf1up5wyiq1">
              Acceso completo
            </div>
          </div>

          <header className="text-center mb-4 mt-1" data-id="element-165" data-mp="hnnlihrxcq8v">
            <h2 className="font-heading font-extrabold text-[1.45rem] sm:text-[2.1rem] text-white tracking-tight leading-none mb-1.5" data-id="element-166" data-mp="hp8ei2ylc14m">
              ATLAS CLÍNICO™
            </h2>
            <p className="text-[12px] sm:text-[14px] text-gold/90 leading-snug max-w-xs mx-auto" data-id="element-167" data-mp="19fuzfag1pojk">
              Sistema de Consulta y Razonamiento Clínico para Kinesiología y
              Fisioterapia
            </p>
          </header>

          <ul className="grid grid-cols-1 gap-y-1.5 mb-4 max-w-xs mx-auto" data-id="element-168" data-mp="10kfbfa1z23lw">
            {INCLUDES.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] sm:text-[13.5px] text-gray-200 leading-snug" data-id="element-169" data-mp="1x68rv22jlpeo">
                <span className="mt-[2px] w-4 h-4 rounded-full bg-clinic/15 border border-clinic/50 flex items-center justify-center flex-shrink-0" data-id="element-170" data-mp="3b2a6vi4spt1r">
                  <Check size={10} className="text-clinic-light" strokeWidth={3} data-id="element-171" data-mp="3k0m6uarjy36v" />
                </span>
                <span data-id="element-172" data-mp="3tzbcn566bx6r">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-4" data-id="element-173" data-mp="3tx794oc6t070">
            <p className="text-[9.5px] sm:text-[11px] font-bold uppercase tracking-[0.16em] text-gray-400 mb-1.5" data-id="element-174" data-mp="2s77kftlal0z">
              Acceso completo por solo
            </p>
            <div className="font-heading font-extrabold text-white tracking-tight leading-none flex items-baseline justify-center gap-1" data-id="element-175" data-mp="blasf96ke05n">
              <span className="text-[1.6rem] sm:text-[2rem] text-gold" data-id="element-176" data-mp="glgdu7m8qqfa">US$</span>
              <span className="text-[3.6rem] sm:text-[4.6rem]" data-id="element-177" data-mp="liyn5z4677nt">12.99</span>
            </div>
            <p className="text-[11.5px] sm:text-[13px] text-gray-400 mt-2" data-id="element-178" data-mp="7w9fukco1e0y">
              Pago único · Sin suscripciones
            </p>
            <p className="inline-flex items-center gap-1.5 mt-2.5 text-[10.5px] sm:text-[12px] font-semibold text-clinic-light bg-clinic/10 border border-clinic/35 rounded-full px-3 py-1.5" data-id="element-179" data-mp="2wwr1u28hwvq">
              <Globe size={12} strokeWidth={2.2} className="flex-shrink-0" data-id="element-180" data-mp="cosu7jj6gd6t" />
              Paga en tu moneda local
            </p>
          </div>

          <a href={CHECKOUT_URL} target="_top" rel="noopener" onClick={() => trackInitiateCheckout(OFFER)} className="group block w-full text-center bg-gold hover:bg-gold-hover text-navy-950 font-extrabold text-[14px] sm:text-[17px] px-4 py-4 sm:py-5 rounded-2xl transition-[transform,background-color] duration-200 ease-out hover:scale-[1.02] shadow-[0_12px_32px_rgba(201,168,76,0.35)]" data-id="element-181" data-mp="3l54ctbmuqx3p">
            <span className="inline-flex items-center gap-2 leading-tight" data-id="element-182" data-mp="15bnby8om0ygl">
              SÍ, QUIERO ACCEDER A ATLAS CLÍNICO
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-200 ease-out flex-shrink-0" data-id="element-183" data-mp="1cxr2nkku21uu" />
            </span>
          </a>

          <p className="mt-3 text-center text-[11px] sm:text-[12.5px] text-gray-400" data-id="element-184" data-mp="17wlbhr6tmmnf">
            🔒 Pago seguro con tarjeta · Acceso inmediato
          </p>
        </motion.div>
      </div>
    </AnimatedSection>;
}